import colors from '~/styles/colors';

export const taskTypeColors = [
  { id: 'grey', name: 'Grey', hex: colors.grey55 },
  { id: 'grey-light', name: 'Light Grey', hex: colors.grey20 },
  { id: 'teal', name: 'Teal', hex: colors.primary100 },
  { id: 'teal-light', name: 'Light Teal', hex: colors.primary50 },
  { id: 'green-light', name: 'Light Green', hex: colors.success50 },
  { id: 'yellow-light', name: 'Light Yellow', hex: colors.warning50 },
  { id: 'red-light', name: 'Light Red', hex: colors.danger50 },
];

export function getColorHex(colorId) {
  const color = taskTypeColors.find((c) => c.id === colorId);
  return color?.hex ?? colors.grey55;
}

export default { taskTypeColors, getColorHex };
